export const isEmpty = (string) => {
    return (!string || 0 === string.length || string === undefined || string === '0' || string === 0);
}
